import React from "react";
import "./statusbar.css";

const StatusBar = ({ stages = [], onStatusClick, disabled = false }) => {
  return (
    <div className="status-box">
      {stages.map((stageObj) => {
        const stageName = stageObj.appointmentStage ? stageObj.appointmentStage.toLowerCase() : "";

        return (
          <div
            key={stageObj.id}
            style={{
              border: "none",
              flex: 1,
              cursor: disabled ? "not-allowed" : "pointer",
              fontSize: "12px",
              fontWeight: 600,
              padding: "8px 40px",
              paddingLeft: "5px",
              paddingRight: "25px",
              textAlign: "center",
              marginLeft: "-15px",
              backgroundColor: stageName === "cancelled" ? "red" : "rgba(22, 170, 16, 0.938)",
              color: "white",
              borderTopRightRadius: "150px",
              borderBottomRightRadius: "150px",
              clipPath: "polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%)",
            }}
            onClick={disabled ? null : () => onStatusClick(stageObj.id)}
          >
            {stageObj.appointmentStage || "Unknown"} 
          </div>
        );
      })}
    </div>
  );
};

export default StatusBar;
